<template>
    <main id="succes-redeem-wrapper">
        <div id="succes-redeem-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url + '/', status: false },
                    { title: 'HCID', url: app_url + '/hcid', status: false },
                    { title: 'Event', url: app_url + '/event', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-5">
                <div class="row text-center justify-content-center">
                    <div class="col-md-4">
                        <img
                            :src="base_url + '/images/check.png'"
                            id="img-check"
                            alt=""
                        />
                        <div class="row pt-5">
                            <div class="col">
                                <h3 class="desc-info">
                                    Selamat Anda Berhasil Join Event
                                </h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" v-if="isPayment">
                                <div v-if="transaction.payment_type === 'cod'">
                                    <p class="detail">
                                        Terima Kasih Anda telah Melakukan Update
                                        Nomor Telepon dan melakukan Update Nopol
                                        Motor.
                                    </p>
                                    <p class="detail">
                                        Jangan lupa untuk melakukan registrasi
                                        ulang dan melakukan pembayaran untuk
                                        mendapatkan starter kit di area
                                        registrasi
                                        <strong
                                            >{{ event.name }},
                                            {{ event.province }}</strong
                                        >
                                    </p>
                                </div>
                                <div v-else>
                                    <p class="detail">
                                        Terima Kasih Anda telah Melakukan Update
                                        Nomor Telepon dan melakukan Update Nopol
                                        Motor.
                                    </p>
                                    <p class="detail">
                                        Untuk Pembayaran Starterkit Honda Bikers
                                        Day Nasional telah berhasil.
                                    </p>
                                    <p class="detail">
                                        Jika ingin melihat bukti pembayaran bisa
                                        cek di Pesan Email BradSis.
                                    </p>
                                    <p class="detail">
                                        Apabila tidak menerima bukti pembayaran,
                                        maka BradSis bisa mengirimkan Pesan
                                        Direct di Instagram
                                        <strong
                                            ><a
                                                href="https://www.instagram.com/honda.community"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                >@Honda.Community</a
                                            ></strong
                                        >
                                    </p>
                                </div>
                            </div>
                            <div class="col" v-else>
                                <p class="detail">
                                    Terima kasih anda telah update nomor
                                    telepon, update nopol motor, dan berhasil
                                    join event {{ event.name }} .
                                </p>
                            </div>
                        </div>
                        <div class="row py-4">
                            <div class="col">
                                <a @click="trackerClick()">
                                    <span class="btn btn-red">
                                        Ke Halaman Profile</span
                                    >
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import { encrypt, decrypt } from "../../../lib/crypto";

export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            base_url: "",
            app_url: "",
            api_url: "",
            mobile: false,
            isPayment: false,
            event: {},
            transaction: {},
            event_attend: {}
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.event = localStorage.getItem("event-hbd")
            ? JSON.parse(localStorage.getItem("event-hbd"))
            : {};

        this.handleGetDataEventAttendLocalStorage();
        this.handleGetDataTransactionLocalStorage();

        console.log(this.isPayment);

        setTimeout(() => {
            this.trackerOnload();
        }, 2500);

        if (localStorage.getItem("event-attend-hbd") !== null) {
            localStorage.removeItem("otp-code");
            localStorage.removeItem("update-police-number");
        } else {
            this.$router.push({ path: "/community/hcid" });
        }
    },
    methods: {
        trackerOnload() {
            let transactionId = null;
            let paymentOption = null;

            if (Object.keys(this.transaction).length) {
                transactionId = this.transaction.external_id;
                paymentOption = this.transaction.payment_provider
                    ? `${this.transaction.payment_type} - ${this.transaction.payment_provider}`
                    : this.transaction.payment_type;
            }

            let data = {
                event: "successJoinEvent",
                eventName: this.event.name, //Event Name
                id: this.event.id, //Event ID
                eventType: this.event.type, //Event Type
                startDate: this.event.start_date, //Event Start Date
                endDate: this.event.end_date, //Event End Date
                publishedDate: this.event.created_at, //Event Created Date
                motorCategory: this.event_attend.category_motor.name,
                motorVariant: this.event_attend.variant_motor.name,
                province: this.event.province, //Event Province,
                transactionId,
                paymentOption
            };
            console.log(data, "successJoinEvent - onload");
            dataLayer.push(data);

            localStorage.removeItem("event-attend-hbd");
            localStorage.removeItem("transaction-hbd");
            localStorage.removeItem("payment-event");
            localStorage.removeItem("openpopup-regis-phone");
            localStorage.removeItem("event-hbd");
            localStorage.removeItem("payment-event");
        },
        trackerClick() {
            let data = {
                event: "panelTracking",
                "eventDetail.category": "Panel Tracking",
                "eventDetail.action": "LIhat Status Event",
                "eventDetail.label": window.location.href,
                sourcePageTitle: "Thank you",
                destinationPageUrl: `${this.app_url}/checklist-join-event`,
                destinationPageTitle: "Checklist Join Event",
                Option: "Thank you page event"
            };
            console.log(data);
            dataLayer.push(data);
            // localStorage.removeItem("event-attend-hbd");
            // localStorage.removeItem("transaction-hbd");
            // localStorage.removeItem("payment-event");
            // localStorage.removeItem("openpopup-regis-phone");
            // localStorage.removeItem("event-hbd");
            // localStorage.removeItem("payment-event");
            this.$router.push({ path: "/community/hcid" });
        },
        async handleGetDataEventAttendLocalStorage() {
            const eventAttendEncrypt = localStorage.getItem("event-attend-hbd");
            if (eventAttendEncrypt) {
                await this.handleDecrypt(eventAttendEncrypt).then(data => {
                    const eventAttend = JSON.parse(data);
                    this.event_attend = eventAttend;
                });
            }
        },
        async handleGetDataTransactionLocalStorage() {
            this.loader = true;
            const transactionEncrypt = localStorage.getItem("transaction-hbd");
            if (transactionEncrypt) {
                await this.handleDecrypt(transactionEncrypt).then(data => {
                    this.transaction = JSON.parse(data);
                    this.isPayment = this.transaction;
                });
            }
        },
        async handleEncrypt(input) {
            try {
                const encryptText = await encrypt(
                    input,
                    process.env.MIX_ENCODED_SECRET_KEY
                );
                return encryptText;
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        async handleDecrypt(input) {
            try {
                return await decrypt(input, process.env.MIX_ENCODED_SECRET_KEY);
            } catch (error) {
                // window.location.href = `${this.event.detail_url_web}/verification-police-number`;
                return false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
#succes-redeem-page {
    background: #000000;

    .desc-info {
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
    }

    .detail {
        font-style: normal;
        font-weight: 300;
        font-size: 15px;
        line-height: 24px;
        text-align: center;
        color: #ffffff;
    }

    .title-row {
        background: #181818;
        opacity: 0.95;
        font-family: Manrope;
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 42px;
        color: #ffffff;
    }

    .info-row {
        background: #1e1e1e;
    }

    #img-info {
        max-height: 25px;
    }

    #img-check {
        max-height: 60px;
    }

    .btn {
        width: fit-content;
        height: 50px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .btn:hover {
        color: white;
        text-decoration: none;
    }

    .btn-white {
        border: 1px solid #dbdbdb;
        box-sizing: border-box;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #e61b33;
    }

    .btn-red {
        background: #e61b33;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #ffffff;
    }
}
</style>
